<div class="ledger-detail">
  @if (Loading) {
  <p class="muted" role="status">Loading ledger entry…</p>
  } @else if (ErrorMessage) {
  <p class="error" role="alert">{{ ErrorMessage }}</p>
  } @else if (Transaction) {
  <fieldset class="rms-fieldset">
    <legend>Entry {{ Transaction.TransactionID }}</legend>
    <div class="detail-grid">
      <div class="field"><label>Date</label><div>{{ Transaction.TransactionDate ? (Transaction.TransactionDate | date:'MM/dd/yyyy':'UTC') : '—' }}</div></div>
      <div class="field"><label>Status</label><div>{{ Transaction.Status }}</div></div>
      <div class="field"><label>Source</label><div>{{ Transaction.SourceType }}</div></div>
      <div class="field"><label>Account</label><div>{{ Transaction.AccountNumber ? Transaction.AccountNumber + ' ' + Transaction.AccountName : '—' }}</div></div>
      <div class="field"><label>Account Type</label><div>{{ Transaction.AccountType || '—' }}</div></div>
      <div class="field"><label>Customer</label><div>{{ Transaction.CompanyName || '—' }}</div></div>
      <div class="field"><label>Payor / Payee</label><div>{{ Transaction.PayorOrPayee || '—' }}</div></div>
      <div class="field"><label>Deposit</label><div>{{ Transaction.DepositAmount | currency:'USD' }}</div></div>
      <div class="field"><label>Withdrawal</label><div>{{ Transaction.WithdrawalAmount | currency:'USD' }}</div></div>
      <div class="field"><label>Payment Method</label><div>{{ Transaction.PaymentMethodName || '—' }}</div></div>
      <div class="field"><label>Legacy Payment Info</label><div>{{ Transaction.LegacyPaymentText || '—' }}</div></div>
      <div class="field"><label>References</label><div>{{ References }}</div></div>
      <div class="field wide"><label>Description</label><div>{{ Transaction.TransactionDescription || '—' }}</div></div>
    </div>
    @if (Transaction.DateNeedsReview) {
    <p class="warning" role="status">This entry's date is missing or before 1990 and needs review by Accounting.</p>
    }
  </fieldset>

  <fieldset class="rms-fieldset">
    <legend>Payments</legend>
    @if (Payments.length) {
    <rms-table [data]="Payments" [columns]="PaymentColumns" [IncludePaginator]="false" [IncludeSearch]="false" tableId="ledger-detail-payments"></rms-table>
    } @else {
    <p class="muted">No customer payment is linked to this entry.</p>
    }
  </fieldset>

  <fieldset class="rms-fieldset">
    <legend>Orders / Invoices</legend>
    @if (Orders.length) {
    <rms-table [data]="Orders" [columns]="OrderColumns" [IncludePaginator]="false" [IncludeSearch]="false" tableId="ledger-detail-orders"></rms-table>
    } @else {
    <p class="muted">No order or invoice is linked to this entry.</p>
    }
  </fieldset>
  }
</div>
